import { render, staticRenderFns } from "./screen_printing.vue?vue&type=template&id=60ddc6fa&scoped=true&"
import script from "./screen_printing.vue?vue&type=script&lang=js&"
export * from "./screen_printing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddc6fa",
  null
  
)

export default component.exports